// Styling for the navigation tobs on top border of main display area in Dashboard
import styled from 'styled-components';

export const TabLabels = styled.div`
  background: var(--color-surface-3);
  border-radius: 10px 10px 0 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

interface ITabLabelProps {
  selected?: boolean;
  activeElevation?: number;
}

const getBackground = (props: ITabLabelProps): string => {
  const fallback = 'var(--color-surface-6)';
  if (props.selected) {
    return props.activeElevation
      ? `var(--color-surface-${props.activeElevation})`
      : fallback;
  }
  return 'transparent';
};
export const TabLabel = styled.div<ITabLabelProps>`
  background: ${getBackground};
  border-radius: 10px 10px 0px 0px;
  box-shadow: ${(props: ITabLabelProps): string =>
    props.selected ? 'var(--shadow-elevation-6)' : 'none'};
  clip-path: ${(props: ITabLabelProps): string =>
    props.selected ? 'inset(0px -18px 0px -18px)' : 'none'};
  display: flex;
  flex-direction: row;
  flex: 1;
  transition-property: background;
  transition-timing-function: ease-in-out;
  transition-duration: 0.25s;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  cursor: pointer;
  font-size: 16px;
`;
